<template>
  <div v-if="!assets.length" class="py-6">
    <EHeroContent
      icon="folder-open"
      :title="t(useTranslationPath(callerPath, 'emptyTitle'))"
      :description="t(useTranslationPath(callerPath, 'emptyDescription'))"
    />
  </div>
  <EList v-else>
    <template v-for="asset in assets" :key="asset.id">
      <EListItem
        :title="asset.asset_model_name"
        :status="asset.status_status"
        :status-variant="asset.status_status_variant"
      >
        <EListItemProperty
          :label="t(useTranslationPath(callerPath, 'serialNumber'))"
          :value="asset.serial_number ?? t(useTranslationPath(callerPath, 'none'))"
        />
        <EListItemProperty
          :label="t(useTranslationPath(callerPath, 'warrantyParts'))"
          :value="
            asset.warranty_parts
              ? useDayJs(asset.warranty_parts).format('L')
              : t(useTranslationPath(callerPath, 'none'))
          "
        />
      </EListItem>
    </template>
  </EList>
</template>

<script setup>
import useDayJs from '@/composables/useDayJs.js'
import { useTranslationPath } from '@/composables/useTranslationPath.js'
import { EHeroContent, EList, EListItem, EListItemProperty } from '@expansivefm/eds'
import { useI18n } from 'vue-i18n'

defineProps({
  assets: {
    type: Array,
    default: () => [],
  },
})

const { t } = useI18n()

const callerPath = 'components.workOrder.assets'
</script>
